function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
import AlertCircleIcon from "../../../../../shared/icons/AlertCircleIcon";
import styles from "./RadioInput.module.scss";
const RadioInput = ({
  registerProps,
  isError,
  fieldSettings,
  text
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: styles.radioWrapper
  }, fieldSettings?.options?.map(option => /*#__PURE__*/React.createElement("div", {
    key: option?.id,
    className: `${styles.radioInput}`
  }, /*#__PURE__*/React.createElement("input", _extends({
    id: option?.id,
    value: text[option?.label?.textId],
    type: "radio"
  }, registerProps)), /*#__PURE__*/React.createElement("label", {
    htmlFor: option?.id,
    id: "general-text",
    style: {
      cursor: "pointer"
    },
    className: "general-input-label"
  }, text[option?.label?.textId]))), isError && /*#__PURE__*/React.createElement(AlertCircleIcon, null));
};
export default RadioInput;
//# sourceMappingURL=RadioInput.js.map